import React from "react";
import "./Aboutus.css";
import aboutimg from "./aboutimg.jpg";
import BH from "./clients/BH.png";
import im2 from "./clients/img2.jpg";
import im3 from "./clients/img3.png";
import im4 from "./clients/img4.jpg";
import im5 from "./clients/img5.jpg";
import im6 from "./clients/img6.png";
import im7 from "./clients/img7.jpg";
import im8 from "./clients/img8.png";
import im10 from "./clients/img10.jpg";
import im11 from "./clients/img11.png";
// slider
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Aboutus = () => {
  const settings1 = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 4,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
  };
  return (
    <div className="main-about">
      <div className="about">About us</div>
      <div className="main2">
        <div className="about-office">
          <p className="aboutp">
            <span>Office</span>
          </p>
          <img src={aboutimg} alt="img"></img>
        </div>

        <div className="about-us">
          <div className="us">
            <p className="aboutp">
              <span>About us</span>
            </p>
          </div>
          <p>
            It is a great pleasure to introduce ourselves, as a leading
            ‘Customized solution provider for Industrial chains’. Swajit
            Engineering Pvt.Ltd. is based at Aurangabad (M.S), India. Swajit has
            evolved in as the leading Conveyor chain manufacturer,Conveyor chain
            supplier & Conveyor chain exporter of all type of Roller conveyor
            chains and any types of Link, Pin and Bush mechanism for Material
            handling systems.Also we are manufacturing 2″,2.5″,3″ & 3.5″
            Simplex,Duplex & Triplex transmission chains.
            <br></br>
            Since the inception in 1992; Swajit is equipped with latest
            technology comprising ‘state-of-art-plant’ with all Infrastructure
            facilities & processes, advanced metallurgical laboratory to
            manufacture all types Conveyor chains and Slats of finest quality.
            <br></br>
            Swajit has a dedicated and technically qualified team of experienced
            Engineers & Metallurgists for fulfilling precisely the customer’s
            needson the continuous basis. We have developed an expertise to
            provide a wide range of Conveyor chains and its components for
            diversified industry segments like Sugar, Cement, Automobile, Steel,
            Solvent, Boiler & Thermal power plant, Co-generation, Bakeries,
            Asphalt, Breweries, Chemical & Fertilizers, Bottling, Food
            Processing, Agriculture, Mining, Paper and Allied Industries.
            <br></br>
            Excellent Quality is Swajit’s inherent strength and in a journey of
            two decades we have strongly emerged as the unchallenged leaders in
            the ever-growing Indian Market and we are now looking beyond the
            boundaries to increase our business in the Global market.We have
            attained this niche position by creating the best products to exceed
            customer expectations, creating everlasting Customer Satisfaction
            with trust and service to generate repeated orders. We adhere to
            global business practices and also we are an ISO 9001: 2008 company
            certified by TUV NORD (Germany).
            <br></br>
            We have a list of valued clients and look forward to add your
            distinguished name into it, hence requesting you to solicit your
            enquiries. Swajit assures excellent solutions to specified your
            specified requirements supported by timely delivery. We look forward
            to build a technically proven & mutually beneficial relationship in
            future.
            <br></br>
            Thanking you and expecting a positive feedback from you, we remain.
          </p>
          <p>
            <br></br>
            Yours Sincerely,
            <br />
            Ajeet A. Chavan
            <br />
            (Managing Director)
            <br />
            Swajit Engineering Pvt.Ltd.
            <br />
            (A leading Conveyor Chain Manufacturer,Supplier & Exporter of all
            type of Roller conveyor chains,Transmission chains & Slates since
            1992)
          </p>
        </div>
      </div>
      <div class="together">
        <div className="work">
          <p>6 Reasons to work together</p>
        </div>
        <div class="perfect">
          <p>Precise and Perfect</p>
          <p>Fullproof Inhouse Facilities</p>
          <p>Customized Commitments</p>
          <p>Exceeding Excellence Forever</p>
          <p>Assured Service Backup</p>
          <p>Strong R & D Wing</p>
        </div>
      </div>
      <div class="swa3">
        <p>SWAJIT</p>

        <p className="swap">
          <q>
            This is our dedicated team which work together to bring our clients
            the most amazing products for connecting the world.
          </q>
        </p>
      </div>
      <div class="slider9">
        <Slider className="ccc1" {...settings1}>
          <div>
            <img src={BH} alt="Slid 1" />
          </div>
          <div>
            <img src={im2} alt="Slid 2" />
          </div>
          <div>
            <img src={im3} alt="Slid 3" />
          </div>
          <div>
            <img src={im4} alt="Slid 5" />
          </div>
          <div>
            <img src={im5} alt="Slid 4" />
          </div>
          <div>
            <img src={im6} alt="Slid 6" />
          </div>
          <div>
            <img src={im7} alt="Slid 7" />
          </div>
          <div>
            <img src={im8} alt="Slid 8" />
          </div>
          <div>
            <img src={im10} alt="Slid 9" />
          </div>
          <div>
            <img src={im11} alt="Slid 10" />
          </div>
        </Slider>
      </div>
    </div>
  );
};

export default Aboutus;
